import {DateOnly} from "./DateOnly";
import {DateTime} from "./DateTime";
import {TimeOnly} from "./TimeOnly";
import {TimeSpan} from "./TimeSpan";

const _dateRegExp: RegExp = /^\d{4}-\d{2}-\d{2}$/;
const _timeRegExp: RegExp = /^\d{2}:\d{2}:\d{2}$/;
//solo el formato largo con días ("d.hh:mm:ss[.fff]"): un "hh:mm:ss" pelado es indistinguible de un TimeOnly
const _timeSpanRegExp: RegExp = /^-?\d+\.\d{2}:\d{2}:\d{2}(?:\.\d+)?$/;
const _dateTimeRegExp: RegExp = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;

function reviver(this: any, _key: string, value: any, context: { source: string } | null): any {
	if (value == null) {
		return null;
	}

	const typeOf = typeof value;
	if (context != null && typeOf === "number" && value.toString() != context.source) {
		//solo devuelvo el texto cuando el double realmente pierde dígitos (longs > 2^53, >15 dígitos
		//significativos); una diferencia solo de formato (10.50, 1e3, -0) sigue siendo un número
		if (!Number.isSafeInteger(value)) {
			const mantissa = context.source.replace(/[-+.]|[eE].*$/g, "").replace(/^0+|0+$/g, "");
			if (mantissa.length > 15) {
				return context.source;
			}
		}
	}

	//opt: si la longitud del string supera el máximo de un ISO 8601 con offset y fracción
	//(p. ej. DateTimeOffset de .NET "2026-07-01T14:18:24.1234567+02:00" = 40 chars), no parseo.
	if (typeOf === "string" && value.length <= 40) {
		if (_dateTimeRegExp.test(value)) {
			return DateTime.fromIsoString(value);
		}

		if (_dateRegExp.test(value)) {
			return DateOnly.fromIsoString(value);
		}

		if (_timeRegExp.test(value)) {
			return TimeOnly.fromIsoString(value);
		}

		if (_timeSpanRegExp.test(value)) {
			return TimeSpan.fromIsoString(value);
		}

		return value;
	}

	return value;
}

export default function decodeJson<T>(data: string): T | undefined {
	if (data == null || data.length === 0) {
		return undefined;
	}

	// @ts-ignore
	return JSON.parse(data, reviver);
}
